import React from 'react';
interface LogoProps {
  className?: string;
  variant?: 'dark' | 'light';
}
const JAG_LOGO_URL = 'https://cdn.magicpatterns.com/uploads/dSBnrGub6fQ4M3vnfGo7tW/jag-header-logo-white-navy.png';
export function Logo({
  className = '',
  variant = 'dark'
}: LogoProps) {
  const isFooter = variant === 'light';
  return <div className={`relative flex shrink-0 items-center ${isFooter ? 'h-[72px] w-[min(320px,calc(100vw-40px))]' : 'h-[58px] w-[min(230px,calc(100vw-104px))] sm:h-[64px] sm:w-[280px] xl:h-[70px] xl:w-[320px]'} ${className}`} data-id="element-418" data-mp="3v9pk8whiwbga">
      <img src={JAG_LOGO_URL} alt="JAG Medical Solutions" className="block h-full w-full object-contain object-left" data-id="element-419" data-mp="rpuwsijgt65z" />
    </div>;
}